import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("g", { fill: "#111928" }, [
      _createElementVNode("path", { d: "M18 12a2 2 0 1 0 0-4 2 2 0 0 0 0 4M10 12a2 2 0 1 0 0-4 2 2 0 0 0 0 4M2 12a2 2 0 1 0 0-4 2 2 0 0 0 0 4" })
    ], -1)
  ]))]))
}
export default { render: render }